import { DateFieldUI } from '@axo/form/feature/form-input/DateField/DateFieldUI';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { TextFieldUI } from '@axo/form/feature/form-input/TextField/TextFieldUI';
import { EmploymentStatus } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { employmentOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import type { EmploymentFormGroupData } from '../../../FormData.no.types';
import styles from '../../../loan.module.scss';
import {
  employerFieldOption,
  employmentStatusFieldOption,
  employmentStatusSinceFieldOption,
} from './config';

export function EmploymentFormGroup() {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  const employmentStatus = useWatch({
    name: 'LoanApplication/EmploymentStatus',
  });

  const askEmploymentDetails = useMemo(
    () =>
      [
        EmploymentStatus.Entrepreneur,
        EmploymentStatus.Temporary,
        EmploymentStatus.Permanent,
        EmploymentStatus.PermanentPublic,
      ].includes(employmentStatus),
    [employmentStatus]
  );

  return (
    <div className={styles.inputGroup} data-grey={true}>
      <Grid columns={gridColumns}>
        <DropdownFieldUI<EmploymentFormGroupData>
          name="LoanApplication/EmploymentStatus"
          label={t('EmploymentStatus.label')}
          data-testid="employment-dropdown"
          options={employmentOptions}
          {...employmentStatusFieldOption}
        />

        {askEmploymentDetails && (
          <>
            <div className={styles.dateFieldUI}>
              <DateFieldUI<EmploymentFormGroupData>
                name="LoanApplication/EmploymentStatusSince"
                label={t('EmploymentStatusSince.label')}
                data-testid="employment-status-since-dropdown"
                minYear={currentYear - 10}
                maxYear={currentYear}
                minYearSuffix={t('EmploymentStatusSince.year.suffix')}
                yearPlaceholder={t('EmploymentStatusSince.placeholder.year')}
                i18n="no-NO"
                showYearOnly
                latestYearAtTop
                disableDatesInFuture
                rules={employmentStatusSinceFieldOption.registerOptions}
              />
            </div>

            <TextFieldUI<EmploymentFormGroupData>
              name="LoanApplication/Employer"
              label={t('Employer.label')}
              data-testid="employer-input"
              {...employerFieldOption}
            />
          </>
        )}
      </Grid>
    </div>
  );
}
